import { useCallback } from 'react';
import { refreshUserLocation } from 'src/common/location/refreshUserLocation';
import { useWaUserStore } from '../store/WaUserStore';
import useWaSecurityService from './WaSecurityService';

export function useWaLocationService() {
  const { user } = useWaUserStore();
  const { waUpdateUserLocation } = useWaSecurityService();

  const updateWaUserLocation = useCallback(async () => {
    const latitude = user?.location?.latitude ?? null;
    const longitude = user?.location?.longitude ?? null;

    const result = await refreshUserLocation(latitude, longitude);

    if (result.latitude != null && result.longitude != null) {
      waUpdateUserLocation(result.latitude, result.longitude);
    }
  }, [user?.location?.latitude, user?.location?.longitude, waUpdateUserLocation]);

  return { updateWaUserLocation };
}
